import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

const getContentfulDocumentPlainText = document => {
  return documentToPlainTextString(document)
}

export {getContentfulDocumentPlainText}
